import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LibraryItem } from "../types/library";
import dreamWorldProvider from "../DreamWorldProvider";
import { Heart, Eye } from "lucide-react";
import LoadingIndicator from "../components/ui/LoadingIndicator";
import PageLayout from "../components/ui/PageLayout";

const ContentPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { contentId } = useParams<{ contentId: string }>();
  const [content, setContent] = useState<LibraryItem | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      if (contentId) {
        try {
          const contentData = await dreamWorldProvider.getContent(contentId);
          if (contentData) {
            setContent(contentData);
          } else {
            setError("Content not found.");
          }
        } catch (err) {
          setError("Failed to fetch content.");
          console.error(err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchContent();
  }, [contentId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-slate-900 text-white">
        <LoadingIndicator />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen bg-slate-900 text-white">
        <p>{error}</p>
      </div>
    );
  }

  if (!content) {
    return null;
  }

  return (
    <div className="bg-gradient-to-br from-slate-950 via-purple-950 to-slate-900 min-h-screen text-white">
      <PageLayout>
        <div className="max-w-4xl mx-auto">
          <div className="bg-slate-900 rounded-lg shadow-lg overflow-hidden">
            <img
              src={content.fullUrl}
              alt={content.title}
              className="w-full h-auto"
            />
            <div className="p-6">
              <h1 className="text-3xl font-bold mb-2">{content.title}</h1>
              <p className="text-gray-400 mb-4">{content.description}</p>
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1">
                  <Heart className="text-red-500" />
                  <span>{content.likes}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Eye className="text-blue-500" />
                  <span>{content.views}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default ContentPage;
